<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">How to pitch us</h1>
                <span class="meta"> Posted in April 2024 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/shizen_pitch_bw.jpg" alt="">
                </figure>

                <p>As General Partners of Shizen Capital, we consider ourselves very fortunate to work as venture capitalists. We each also happen to have founded tech startups in our prior careers before entering the VC world. Although we would love to believe that we are brilliant, the reality is that we’ve been lucky. Any flashes of wisdom we do show on occasion comes from the dizzying volume of mistakes we made as entrepreneurs or later as naive investors in our early VC days. Any ostensible brilliance derives mainly from the catbird seat our job affords us to witness growing tech companies over and over again.</p>
                <p>So when we write a piece entitled “How to pitch us,” we're doing it not to preach wisdom from a textbook, but rather to provide pragmatic advice in the pursuit of two specific goals: i) to help us be good stewards of the capital we’ve been conferred to manage, and ii) to optimize your time as founders, from which we feel honored to be benefiting, and maximize your chances of success.</p>
                <p>We receive hundreds of investment solicitations every year and, as much as we try, cannot possibly respond to every single one of them. Here are some practical suggestions on how best to attract our attention and make a compelling investment pitch to us.</p>

                <h2 class="subheading">The approach:</h2>
                <p>Your goal in the approach is not to convince us to invest, but rather to convince us to schedule an introductory meeting or conference call with you.</p>
                <ul>Rise above the noise level by contacting us via an endorsed introduction (e.g. such as via our portfolio companies or a trusted person in our network).</ul>
                <ul>That being said, we also pride ourselves in being accessible, so please do not be afraid to reach out directly, especially in creative ways. When Mark was recently solicited by an entrepreneur who had made a habit of constructively commenting on his blog posts, he didn’t hesitate a split second to schedule a meeting with him.</ul>
                <ul>Pre-qualify the relevance of a prospective meeting with us by reading the description of our investment sweet spot. Explain how your company fits if the fit is not obvious. You can also gain insight into our investment philosophy by reading Mark’s blog and reviewing our portfolio companies.</ul>
                <ul>We also expect that you will have reflected on whether VC funding is appropriate for your startup before contacting us. We recommend reading our post on VC Math related to this topic.</ul>
                <ul>Please don’t ask us to sign an NDA up front (see a more detailed rationale). Send us something non-confidential that wouldn’t upset you if we solicited the opinion of a trusted advisor.</ul>
                <ul>Send a clear and concise executive summary (we’re not hung up on the format of it, however, often we may be reading your email while off the grid, so anything requiring us to re-connect or access some cloud links often slips through).</ul>
                <ul>It almost goes without saying that the following techniques are very ineffective: mass email intros to multiple recipients, cold emails requesting a call back, or generic emails clearly absent any review of our investment scope and philosophy.</ul>

                <h2 class="subheading">The first meeting:</h2>
                <ul>Prepare for an efficient discussion limited to one hour. 50 minutes is even better, as it will allow us to be punctual for the meeting following yours.</ul>
                <ul>Demonstrate that you’ve identified the problem, and clearly explain your vision of a solution.</ul>
                <ul>Tell us specifically what you’d like from us.</ul>
                <ul>We are more intrigued by your ambition than by your planification exercise in exit strategy (e.g. “We plan to IPO on TSE Growth in 7 years.”), which betrays naïveté in a context of abundant uncertainty.</ul>

                <h2 class="subheading">Our commitment to you:</h2>
                <ul>We will give you our full undivided attention in our meeting. That means no distracting behavior on our smartphone with email, etc. during our session together.</ul>
                <ul>We will not waste your meeting time by grandstanding you with our accomplishments. In fact, we will try to speak as briefly as possible about ourselves and our firm, and only insofar as relevant for our interaction (unless of course, you want us to do so; the point is: the hour is yours to focus on what you deem most important).</ul>
                <ul>We will offer you a decent cup of coffee or tea. If our uncultivated nature lets this basic courtesy slip our minds, feel free to smack us.</ul>
                <ul>We will be straightforward about our investment intentions post-meeting. If we do not intend to invest at this time, we will make this clear as early as possible so that you can move on. We will not string you along with a never-ending due diligence ordeal. We can decide on investments quickly, and we can move quickly. Sometimes, however, we simply lack enough bandwidth to prioritize your investment even when we are interested. Regardless, we will tell you so.</ul>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
